$(".reviews-slider").owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    smartSpeed: 800,
    center: true,
    margin: 0,
    autoplayHoverPause: true,
    autoplay: false,
    responsive: {
        0: {
            items: 2,
            nav: false,
            margin: 13
        },
        576: {
            items: 1.3,
            nav: false,
            margin: 13
        },
        768: {
            items: 1.2,
            margin: 13
        },
        1024: {
            items: 1.2,
            margin: 13
        },
        1200: {
            items: 2.5
        }
    }
});

$(".hero-slider").owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    smartSpeed: 800,
	navText: ["<img src='https://cdn.shopify.com/s/files/1/0856/3559/6594/files/arrow_left.webp' alt='left-arrow'>", "<img src='https://cdn.shopify.com/s/files/1/0856/3559/6594/files/arrow_right.webp' alt='right-arrow'>"], // Add the paths to your arrow images
    center: true,
    margin: 0,
    mouseDrag: false,
    touchDrag: false,
    autoplayHoverPause: true,
    autoplay: false,
    responsive: {
        0: {
            items: 1.2,
            nav: false,
            margin: 13,
            mouseDrag: true,
            touchDrag: true,
        },
        576: {
            items: 1,
            nav: false,
            margin: 13,
            mouseDrag: true,
            touchDrag: true,
        },
        768: {
            items: 1,
            margin: 13
        },
        1024: {
            items: 1,
            margin: 13
        },
        1200: {
            items: 1
        }
    }
});

$(".home-cat-slider").owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    smartSpeed: 800,
	navText: ["<img src='https://cdn.shopify.com/s/files/1/0856/3559/6594/files/arrow_left.webp' alt='left-arrow'>", "<img src='https://cdn.shopify.com/s/files/1/0856/3559/6594/files/arrow_right.webp' alt='right-arrow'>"], // Add the paths to your arrow images
    center: false,
    margin: 24,
    mouseDrag: false,
    touchDrag: false,
    autoplayHoverPause: true,
    autoplay: false,
    responsive: {
        0: {
            items: 1.5,
            nav: false,
            margin: 13,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
            center: true,
        },
        576: {
            items: 1.5,
            nav: false,
            margin: 13,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
              center: true,
        },
        768: {
            items: 5,
            margin: 13,
            nav:false,
           dots: true,
        },
        1024: {
            items: 5,
            nav:false,
           dots: true,
        },
        1200: {
            items: 5
        }
    }
});

$(".feature-slider").owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    smartSpeed: 800,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/0856/3559/6594/files/arrow_left.webp' alt='left-arrow'>", "<img src='https://cdn.shopify.com/s/files/1/0856/3559/6594/files/arrow_right.webp' alt='right-arrow'>"], // Add the paths to your arrow images
    center: false,
    margin: 24,
    autoplayHoverPause: true,
    autoplay: false,
    responsive: {
         0: {
            items: 1.5,
            nav: false,
            margin: 13,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
            center: true,
        },
        576: {
            items: 1.5,
            nav: false,
            margin: 13,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
              center: true,
        },
        768: {
            items: 2,
            margin: 13,
           nav:false,
           dots: true,
        },
        1024: {
            items: 2,
            nav:false,
           dots: true,
        },
        1200: {
            items: 2
        }
    }
});

$(".speak-slider").owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    smartSpeed: 800,
	navText: ["<img src='https://cdn.shopify.com/s/files/1/0856/3559/6594/files/arrow_left.webp' alt='left-arrow'>", "<img src='https://cdn.shopify.com/s/files/1/0856/3559/6594/files/arrow_right.webp' alt='right-arrow'>"], // Add the paths to your arrow images
    center: false,
    margin: 24,
    mouseDrag: false,
    touchDrag: false,
    autoplayHoverPause: true,
    autoplay: false,
    responsive: {
        0: {
            items: 1.5,
            nav: false,
            margin: 13,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
            center: true,
        },
        576: {
            items: 1.5,
            nav: false,
            margin: 13,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
              center: true,
        },
        768: {
            items: 1.5,
            margin: 13,
           nav:false,
           dots: true,
          mouseDrag: true,
          touchDrag: true,
        },
        1024: {
            items: 2,
            nav:false,
           dots: true,
           mouseDrag: true,
          touchDrag: true,
        },
        1200: {
            items: 2
        }
    }
});

$(document).ready(function(){ 
    $('.tab-a').click(function(){  
      $(".tab").removeClass('tab-active');
      $(".tab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
      $(".tab-a").removeClass('active-a');
      $(this).parent().find(".tab-a").addClass('active-a');
     });
});